var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBuyInsurance(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("foreignObject", {
    x: 0,
    y: 0,
    width: 0,
    height: 0
  }, /*#__PURE__*/React.createElement("div", {
    xmlns: "http://www.w3.org/1999/xhtml",
    style: {
      backdropFilter: "blur(2px)",
      clipPath: "url(#bgblur_0_13125_21244_clip_path)",
      height: "100%",
      width: "100%"
    }
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-figma-bg-blur-radius": 4
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 7,
    fill: "#E53B35"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M16.6663 7.33398L8 16.0031",
    stroke: "white",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M18 11.4562V9.52084C18 8.42751 18 7.88084 17.7306 7.52418C17.4612 7.16751 16.8521 6.99436 15.6338 6.64805C14.8015 6.41145 14.0677 6.1264 13.4815 5.86618C12.6823 5.51138 12.2827 5.33398 12 5.33398C11.7173 5.33398 11.3177 5.51138 10.5185 5.86618C9.93226 6.1264 9.19856 6.41144 8.36622 6.64805C7.14795 6.99436 6.53881 7.16751 6.26941 7.52418C6 7.88084 6 8.42751 6 9.52084V11.4562C6 15.2063 9.37518 17.4563 11.0627 18.3469C11.4674 18.5605 11.6697 18.6673 12 18.6673C12.3303 18.6673 12.5326 18.5605 12.9373 18.3469C14.6248 17.4563 18 15.2063 18 11.4562Z",
    stroke: "white",
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "bgblur_0_13125_21244_clip_path",
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    rx: 7
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBuyInsurance);
export default __webpack_public_path__ + "static/media/buyInsurance.ae0cc23ed692c97f382c84913a0c953e.svg";
export { ForwardRef as ReactComponent };